(function () {
  function boot(root) {
    if (!root || root.dataset.launchReady === 'true') return;
    root.dataset.launchReady = 'true';
    initCountdown(root);
    initGallery(root);
    focusResult(root);
  }

  function focusResult(root) {
    var result = root.querySelector('[data-launch-success], [data-launch-error]');
    if (!result) return;
    result.focus({ preventScroll: true });
    result.scrollIntoView({ block: 'center' });
  }

  function initCountdown(root) {
    var timer = root.querySelector('[data-countdown]');
    if (!timer) return;
    var target = new Date(timer.getAttribute('data-target')).getTime();
    var label = root.querySelector('[data-countdown-label]');
    var fields = {
      days: timer.querySelector('[data-days]'),
      hours: timer.querySelector('[data-hours]'),
      minutes: timer.querySelector('[data-minutes]'),
      seconds: timer.querySelector('[data-seconds]')
    };
    if (!fields.days || Number.isNaN(target)) return;

    var intervalId = 0;

    function render() {
      var remaining = Math.max(0, target - Date.now());
      var totalSeconds = Math.floor(remaining / 1000);
      fields.days.textContent = pad(Math.floor(totalSeconds / 86400));
      fields.hours.textContent = pad(Math.floor(totalSeconds / 3600) % 24);
      fields.minutes.textContent = pad(Math.floor(totalSeconds / 60) % 60);
      fields.seconds.textContent = pad(totalSeconds % 60);
      if (remaining === 0) {
        if (label) label.textContent = 'Now live';
        window.clearInterval(intervalId);
      }
    }

    render();
    intervalId = window.setInterval(render, 1000);
    root.launchCountdown = intervalId;
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-launch-gallery]');
    if (!gallery) return;
    var viewport = gallery.querySelector('[data-launch-viewport]');
    var track = gallery.querySelector('[data-launch-track]');
    var dialog = gallery.querySelector('[data-launch-lightbox]');
    var dialogImage = gallery.querySelector('[data-launch-lightbox-img]');
    if (!viewport || !track || !dialog || !dialogImage) return;

    var originals = Array.prototype.slice.call(track.children);
    var count = originals.length;
    if (!count) return;

    var items = originals.map(function (slide) {
      var button = slide.querySelector('[data-launch-open]');
      return {
        full: button ? button.getAttribute('data-full') : '',
        alt: button ? button.getAttribute('data-alt') : ''
      };
    });

    var index = count;
    var logical = 0;
    var slideWidth = 0;
    var currentView = 0;
    var lightboxIndex = 0;
    var suppressClick = false;
    var moving = false;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function perView() {
      if (window.matchMedia('(min-width: 990px)').matches) return 4;
      var width = viewport.clientWidth;
      if (width < 540) return 1;
      if (width < 820) return 2;
      return 3;
    }

    function cloneSlide(node) {
      var clone = node.cloneNode(true);
      clone.setAttribute('data-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      Array.prototype.forEach.call(clone.querySelectorAll('button'), function (button) {
        button.tabIndex = -1;
      });
      return clone;
    }

    function mount() {
      Array.prototype.forEach.call(track.querySelectorAll('[data-clone]'), function (node) {
        node.remove();
      });
      var before = originals.map(cloneSlide);
      var after = originals.map(cloneSlide);
      before.forEach(function (node) {
        track.insertBefore(node, originals[0]);
      });
      after.forEach(function (node) {
        track.appendChild(node);
      });
      currentView = perView();
      index = count + logical;
      measure();
      apply(false);
    }

    function gap() {
      var value = parseFloat(window.getComputedStyle(track).columnGap);
      return Number.isFinite(value) ? value : 10;
    }

    function measure() {
      var view = perView();
      var width = viewport.clientWidth;
      var slideGap = gap();
      if (width < 750) {
        var styles = window.getComputedStyle(viewport);
        var padLeft = parseFloat(styles.paddingLeft) || 0;
        var padRight = parseFloat(styles.paddingRight) || 0;
        var inner = Math.max(0, width - padLeft - padRight);
        slideWidth = Math.round(inner * 0.86);
      } else {
        slideWidth = (width - slideGap * (view - 1)) / view;
      }
      Array.prototype.forEach.call(track.children, function (slide) {
        slide.style.flexBasis = slideWidth + 'px';
      });
    }

    function apply(animate) {
      var shouldAnimate = animate && !reduceMotion;
      track.style.transition = shouldAnimate ? 'transform 460ms ease' : 'none';
      track.style.transform = 'translate3d(' + (-index * (slideWidth + gap())) + 'px, 0, 0)';
      if (!shouldAnimate) track.getBoundingClientRect();
    }

    function go(direction) {
      if (moving) return;
      if (reduceMotion) {
        logical = (logical + direction + count) % count;
        index = count + logical;
        apply(false);
        return;
      }
      moving = true;
      index += direction;
      logical = normalizeLogical(index);
      apply(true);
    }

    function normalizeLogical(position) {
      var value = position - count;
      value = ((value % count) + count) % count;
      return value;
    }

    function settle() {
      var start = count;
      var end = count * 2;
      if (index >= end) index -= count;
      else if (index < start) index += count;
      logical = index - count;
      apply(false);
    }

    track.addEventListener('transitionend', function (event) {
      if (event.target !== track || event.propertyName !== 'transform') return;
      settle();
      moving = false;
    });

    gallery.querySelector('[data-launch-prev]').addEventListener('click', function () {
      go(-1);
    });
    gallery.querySelector('[data-launch-next]').addEventListener('click', function () {
      go(1);
    });

    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        go(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        go(1);
      }
    });

    var wheelLocked = false;
    viewport.addEventListener('wheel', function (event) {
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
      event.preventDefault();
      if (wheelLocked) return;
      wheelLocked = true;
      go(event.deltaX > 0 ? 1 : -1);
      window.setTimeout(function () {
        wheelLocked = false;
      }, 480);
    }, { passive: false });

    bindSwipe(viewport, function (direction) {
      suppressClick = true;
      window.setTimeout(function () {
        suppressClick = false;
      }, 400);
      go(direction);
    });

    viewport.addEventListener('click', function (event) {
      var button = event.target.closest('[data-launch-open]');
      if (!button) return;
      if (suppressClick) {
        suppressClick = false;
        event.preventDefault();
        return;
      }
      openLightbox(Number(button.getAttribute('data-index')));
    });

    function openLightbox(nextIndex) {
      if (!items.length || Number.isNaN(nextIndex)) return;
      lightboxIndex = (nextIndex + count) % count;
      showLightbox();
      if (!dialog.open) dialog.showModal();
    }

    function showLightbox() {
      var item = items[lightboxIndex];
      if (!item) return;
      if (dialogImage.getAttribute('src') !== item.full) dialogImage.setAttribute('src', item.full);
      dialogImage.alt = item.alt || '';
    }

    function stepLightbox(direction) {
      lightboxIndex = (lightboxIndex + direction + count) % count;
      showLightbox();
    }

    gallery.querySelector('[data-launch-lightbox-close]').addEventListener('click', function () {
      dialog.close();
    });
    gallery.querySelector('[data-launch-lightbox-prev]').addEventListener('click', function () {
      stepLightbox(-1);
    });
    gallery.querySelector('[data-launch-lightbox-next]').addEventListener('click', function () {
      stepLightbox(1);
    });

    dialog.addEventListener('click', function (event) {
      if (dialog.dataset.swipe === 'true') return;
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        stepLightbox(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        stepLightbox(1);
      }
    });

    bindSwipe(dialog, function (direction) {
      dialog.dataset.swipe = 'true';
      window.setTimeout(function () {
        delete dialog.dataset.swipe;
      }, 400);
      stepLightbox(direction);
    });

    dialog.addEventListener('close', function () {
      dialogImage.removeAttribute('src');
    });

    mount();

    var resizeObserver = new ResizeObserver(function () {
      var nextView = perView();
      measure();
      if (nextView !== currentView) {
        currentView = nextView;
        index = count + logical;
      }
      apply(false);
    });
    resizeObserver.observe(viewport);
    root.launchResize = resizeObserver;
  }

  function bindSwipe(target, onSwipe) {
    var startX = 0;
    var startY = 0;
    var tracking = false;

    target.addEventListener('pointerdown', function (event) {
      if (event.button !== 0) return;
      if (event.target.closest('button') && event.target.closest('button') !== target && target.tagName === 'DIALOG') return;
      tracking = true;
      startX = event.clientX;
      startY = event.clientY;
    });

    target.addEventListener('pointerup', function (event) {
      if (!tracking) return;
      tracking = false;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return;
      onSwipe(dx < 0 ? 1 : -1);
    });

    target.addEventListener('pointercancel', function () {
      tracking = false;
    });
  }

  function start() {
    document.querySelectorAll('[data-afp-launch]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-afp-launch]');
    if (root) boot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-afp-launch]');
    if (!root) return;
    window.clearInterval(root.launchCountdown);
    if (root.launchResize) root.launchResize.disconnect();
  });
})();
